import FieldMixins from './mixins/field_mixin.js';
import SelectionFieldMixins from './mixins/selection_field_mixin.js';

export default Vue.extend({
  mixins: [FieldMixins, SelectionFieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <Dropdown slot='optionbar'
                :optionGroups='_wrapDropdownOptions(optionbarContent)'
                :initValue='currentOption'
                :optionGroupsFixed='true'
                @change='changeType'>
        <template slot='value-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
        <template slot='option-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
      </Dropdown>
      <template slot='content'>
        <div class="edit-content" v-if='editing'>
          <div class="local-options" :class='{ disabled: remote_options_url }'>
            <div class="options">
              <OptionList :options='field.options'
                          :optionable='field'
                          type='radio'
                          ref='optionsView' />
              <div class="option-item other-option" v-if='otherOption'>
                <div class="option-wrapper justify-box">
                  <i class="slp-circle-o text-strong"></i>
                  <input type="text"
                         class='option-value-input content'
                         v-model.trim='field.other_option'
                         placeholder='其他'
                         ref='otherOptionInput' />
                  <input type="text"
                         class='content option-value-input'
                         placeholder='填写文本'
                         readonly />
                  <span class="option-settings-trigger" @click='toggleOtherOptionSetting'>
                    <i :class='isLimitOn() ? "slp-check" : "slp-empty" '></i>
                    <span>设置上限</span>
                  </span>
                  <span @click='toggleOtherOption' class='destroy-option-btn text-strong'>
                    <i class="slp-times"></i>
                  </span>
                </div>
                <div class="option-settings-container justify-box" v-show='otherOptionSettingEnable'>
                  <label class="setting-item content justify-box">
                    <span>填写上限</span>
                    <input class='content'
                           placeholder='小于0或为空时，无上限'
                           type="number"
                           min=0
                           :value='maxSetting'
                           @blur='updateOtherMaxSetting'
                           @input='updateOtherMaxSetting' />
                  </label>
                  <label class="setting-item content justify-box">
                    <span>提示文案</span>
                    <input class='content'
                           placeholder='超过限制'
                           type="text"
                           :value='textSetting'
                           @blur='updateOtherTextSetting'
                           @input='updateOtherTextSetting' />
                  </label>
                </div>
              </div>
            </div>
            <div class="option-setup">
              <span>添加</span>
              <span class="clickable option-separator" @click='addOption'>选项</span>
              <span>或</span>
              <Popover position='top center' customClass='multiple-input' type='prompt' size='large' ref='popover'>
                <span class="clickable option-separator" slot='trigger'>多个选项</span>
                <template slot='content'>
                  <div class="popover-prompt-content">
                    <div class="popover-prompt-title">
                      <div class='text-strong'>添加多个选项</div>
                      <span class='placeholder text-small'>（使用换行来分割）</span>
                    </div>
                    <div class="popover-prompt-body">
                      <textarea rows="3" ref='multipleInput' placeholder='输入选项'></textarea>
                    </div>
                    <div class="popover-prompt-footer">
                      <button class='btn-default outlined' @click='cancelPopover'>取消</button>
                      <button class='outlined' @click='addOptions'>确定</button>
                    </div>
                  </div>
                </template>
              </Popover>
              <span v-show='!otherOption'>或</span>
              <span class="clickable option-separator"
                    v-show='!otherOption'
                    @click='toggleOtherOption'>其他</span>
            </div>
          </div>
          <div class="remote-option-setting">
            <p>或使用外链选项</p>
            <input type="text" v-model.trim='remote_options_url' placeholder='外链选项地址' />
          </div>
        </div>
        <div class="display-content" v-else>
          <div class="options">
            <div class="normal-options">
              <div class="option-item"
                   v-for='(option, index) in field.options'
                   v-if='!option._destroy'
                   :key='index'>
                <div class="option-wrapper justify-box">
                  <i class="slp-circle-o text-strong"></i>
                  <span class="content">{{ option.textValue() }}</span>
                </div>
              </div>
            </div>
            <div class='option-item other-option' v-if='otherOption'>
              <div class="option-wrapper justify-box">
                <i class="slp-circle-o text-strong"></i>
                <div class="content justify-box">
                  <span>{{ field.otherOption.textValue() }}</span>
                  <div class="option-value-input content placeholder">请输入</div>
                </div>
              </div>
            </div>
          </div>
          <div class="remote-option-display" v-if='remote_options_url'>
            <p>外链选项地址</p>
            <input type="text" readonly='true' :value='remote_options_url' />
          </div>
        </div>
      </template>
      <template slot="replaced-settings">
        <slot name="user-settings" :field="field"></slot>
      </template>
    </FieldView>
  `,
});
